module.exports = __webpack_public_path__ + "static/media/loader.4fdb4717.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.gif
// module id = 7
// module chunks = 0